import { Text, View } from '@react-pdf/renderer';
import styles from '../styles/styles';

interface OverviewProps {
    summeryHeader: string;
    summaryTableHeader: string[];
    summaryRows: [string, ...string[]][];
}

const Overview = ({
    summeryHeader,
    summaryTableHeader,
    summaryRows
}: OverviewProps) => (
    <>
        {/* Header */}
        <View style={styles.row}>
            <Text style={styles.subHeader}>{summeryHeader}</Text>
        </View>
        <View style={styles.miniSpacer} />

        {/* Grid */}
        <View>
            {/* Header Row */}
            <View style={styles.tableRow}>
                {summaryTableHeader.map((dClass, idx) => {
                    const isFirstCol = idx === 0;
                    const isLastCol = idx === summaryTableHeader.length - 1;

                    return (
                        <View
                            key={`header-${idx}`}
                            style={isFirstCol ? styles.firstCol : isLastCol ? styles.lastCol : styles.tableColW}
                        >
                            <Text style={isFirstCol ? styles.headerTextFirstCol : styles.headerText}>{dClass}:</Text>
                        </View>
                    )
                })}
            </View>

            {/* Data Rows */}
            {summaryRows.map((row, rowIndex) => (
                <View key={`row-${rowIndex}`} style={styles.tableRow}>
                    {row.map((cell, colIndex) => {
                        const isFirstCol = colIndex === 0;
                        const isLastCol = colIndex === row.length - 1;

                        return (
                            <View
                                key={`cell-${rowIndex}-${colIndex}`}
                                style={isFirstCol ? styles.firstCol : isLastCol ? styles.lastCol : styles.tableColW}
                            >
                                <Text style={isFirstCol ? styles.alignTableTextFirstCol : styles.alignTableText}>{cell}</Text>
                            </View>
                        );
                    })}
                </View>
            ))}
        </View>
    </>
);

export default Overview;